<!-- 预赛 -->
<template>
    <div class="stage-mod stage-pre-result">
        <div v-if="myPreAwards && myPreAwards.length > 0" class="stage-box stage-box--empty">
        <div class="stage-box__msg">
            <dl>
                <dd>&nbsp;</dd>
                <dd>初赛成绩已公布, 恭喜您获得了:</dd>
                <dd v-if="myPreAwards.length > 1"><span class="red">{{myPreAwards[0].name}}</span>等奖项</dd>
                <dd v-else><span class="red">{{myPreAwards[0].name}}</span></dd>
            </dl>
        </div>
        <van-button size="big" block type="danger" @click="goView">立即查看</van-button>
        </div>
        <div v-else class="stage-box stage-box--simple">
        <div class="stage-box__msg">{{preRes|time2text}}公布初赛成绩、晋级名单、获奖名单</div>
        <van-button size="big" block type="danger" @click="goView">立即查看</van-button>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    import {
        getStorage,
        setStorage
    } from '../../../common/utils'

    const STORE_KEY = 'match_award_dlg'
    export default {
        name: 'pre-result',
        computed: {
            ...mapGetters(['preRes', 'isFinishPre', 'isAdvance', 'myPreAwards']),
            canAlertPreAward() {
                return this.myPreAwards && getStorage(STORE_KEY) !== 'pre'
            }
        },
        watch: {
            canAlertPreAward(can) {
                if(can) {
                    this.alertPreAward()
                }
            }
        },
        methods: {
            ...mapActions(['goLogin']),
            goView() {
                if(this.myPreAwards) {
                    this.$router.push("/match/my/awards")
                } else {
                    this.$router.push("/match/pre")
                }
            },
            async alertPreAward() {
                if(this.canAlertPreAward) {
                    await this.$dialog.alert({
                        title: '获奖通知',
                        message: '<div class="ta_left">尊敬的用户你好，<br>初赛成绩已公布，恭喜你在初赛中获奖啦！<br>快去看看获得了哪些奖项吧！</div>',
                        confirmButtonText: '查看详情'
                    })
                    this.$router.push('/match/my/awards')
                    setStorage(STORE_KEY, 'pre')
                }
            }
        },
        created() {
            if(this.canAlertPreAward) {
                this.alertPreAward()
            }
        }
    }
</script>
